import React from 'react';

const SvgIcons = ({ icon, sx = {}, height = 20, width = 20 }) => {
  return <img src={icon} height={height} width={width} alt="icon" style={sx} />;
};

export default SvgIcons;
